import { Notice } from '@buffer-mono/popcorn'

import { useStartPageSunsetAnnouncementEnabled } from '~publish/hooks/useStartPageSunsetAnnouncementEnabled'

import type { JSX } from 'react'

// The editor app carries the same text in its own `StartPageSunsetNotice`.
const HEADING = 'Start Page is being retired on February 2, 2027'
const TEXT =
  "You can keep editing your Start Page for now. We're building tools to help you migrate your Start Page to somewhere new – more to come soon."

/**
 * Tells someone with a Start Page that the product is being sunset.
 *
 * Renders nothing until `start-page-sunset-announcement` is on. The caller
 * decides whether a Start Page is in view. Deliberately non-dismissible: the
 * whole product is being retired.
 */
export function StartPageSunsetNotice(): JSX.Element | null {
  const isSunsetAnnounced = useStartPageSunsetAnnouncementEnabled()

  if (!isSunsetAnnounced) {
    return null
  }

  return (
    <Notice variant="info">
      <Notice.Text>
        <strong>{HEADING}.</strong> {TEXT}
      </Notice.Text>
    </Notice>
  )
}
